import { TCheckedType } from 'pages/calculation/types/index.type';

type TGetIsCheckedProducts = {
  checkedProducts: [] | TCheckedType;
  productId: string;
};

export const getIsCheckedProducts = ({ checkedProducts, productId }: TGetIsCheckedProducts) =>
  checkedProducts.find(item => item.id === productId)?.isChecked;
